export default "__VITE_ASSET__ad6e3481__"